import { rawChartLevels } from '../component.market.chart/chart-levels';

// Presentation only: reuse the chart's price levels; never decide or submit orders.
export function buildNextActionView(view: any) {
    const levels = rawChartLevels(null, null, view.market, view.chartStrategy)
        .filter(level => level.kind === 'entry' || level.kind === 'entry-high')
        .filter(level => level.price > 0)
        .sort((a, b) => b.price - a.price);
    const entry = !view.cycle && !view.activeOrder ? levels[0] || null : null;
    let title = view.cycle ? view.cycleView.phaseLabel : '첫 매수 대기';
    let detail = view.runtimeReasonLabel;
    let tone = 'neutral';
    const price = Number(view.market.price);
    const comparable = Number.isFinite(price) && price > 0
        && !view.market.delayed && view.market.price_source === 'REALTIME'
        && view.executionHealth.realtime_ready === true
        && view.marketSession === 'REGULAR' && !view.refreshWarning && !view.runtime.stale;
    const distance = entry && comparable ? entry.price - price : null;
    if (view.emergency) {
        title = '긴급 정지'; tone = 'danger';
    } else if (view.refreshWarning || view.runtime.stale) {
        title = '상태 갱신 확인 필요'; tone = 'warning';
        detail = '마지막 확인값입니다. 최신 상태를 확인하고 있습니다.';
    } else if (view.executionMismatch) {
        title = '자동매수 실행 확인 필요'; tone = 'warning';
    } else if (view.cycleView.order) {
        title = view.cycleView.order.label;
        detail = view.cycleView.order.statusLabel;
        tone = view.cycleView.order.tone;
    } else if (view.runtime.daily_loss_latched) {
        title = '오늘 새 매수 종료'; tone = 'warning';
    } else if (!view.dashboard.target) {
        title = '종목 선택 필요';
    } else if (!view.accountMatched || view.accountRefreshDelayed) {
        title = view.accountStatusLabel; tone = 'warning';
        detail = '계좌 확인 상태와 마지막 조회 시각을 확인해주세요.';
    } else if (view.cycleNotice) {
        title = '사이클 확인 필요'; tone = 'warning'; detail = view.cycleNotice;
    } else if (!view.ready) {
        title = '시작 전 확인 필요'; tone = 'warning'; detail = view.readinessMessage;
    } else if (['MARKET_OPEN_AUTO_MISSED', 'AUTO_START_DATE_INVALID'].includes(view.control?.reason_code)) {
        title = view.automationLabel; tone = 'warning';
    } else if (view.marketSession !== 'REGULAR') {
        title = view.chartSessionLabel;
        detail = view.automationEnabled ? '자동매수 설정 유지 · 다음 장 상태를 기다립니다.' : '자동매수 꺼짐';
    } else if (!view.controlRequested) {
        title = view.cycle ? '보유 사이클 · 새 매수 중지' : '자동매수 대기';
        detail = view.autoStartEnabled ? '자동 시작 예약이 켜져 있습니다.' : '자동매수가 꺼져 있습니다.';
    } else if (view.executionHealth.realtime_ready !== true || view.market.delayed) {
        title = '실시간 시세 확인 중'; tone = 'warning';
        detail = '최신 시세를 확인하기 전에는 가격 도달 여부를 표시하지 않습니다.';
    } else if (!view.cycle && entry && distance !== null && view.runtime.reason === 'REALTIME_ENTRY_WAITING') {
        tone = 'live';
        detail = distance < 0
            ? '아직 첫 매수 기준보다 높아 기다리고 있습니다.'
            : '가격 기준 도달 · 주문 여부는 실행 조건 확인 후 결정됩니다.';
    }
    return { title, detail, tone, entry, distance,
        distancePct: distance !== null ? distance / price * 100 : null };
}
